var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('div',{staticClass:"layerpopup-wrap"},[_c('div',{staticClass:"layerpopup-box type-basic"},[_c('div',{class:{
        description: true,
        success: _vm.isSuccess,
        error: _vm.isError,
        warning: _vm.isWarning,
      },domProps:{"innerHTML":_vm._s(_vm.msg)}}),_c('div',{staticClass:"popupbtn-box"},[_c('button',{ref:"alert",class:{
          fullbtn: true,
          success: _vm.isSuccess,
          error: _vm.isError,
          warning: _vm.isWarning,
        },attrs:{"type":"button"},on:{"click":_vm.onClick}},[_vm._v(" "+_vm._s(_vm.$t('NLS0000959'))+" ")])])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }